// Huecos en una serie de mediciones, para cortar la línea del gráfico donde
// faltan datos. Si la estación está sin conexión lo decide el backend (ver
// connectivity.ts), no esto.
export const DEFAULT_STALE_THRESHOLD_MS = 5 * 60 * 1000;
const MIN_STALE_THRESHOLD_MS = 2 * 60 * 1000;
const MAX_STALE_THRESHOLD_MS = 10 * 60 * 1000;

// El intervalo "normal" entre mediciones varía mucho según el dispositivo
// (un ESP32 real puede reportar cada 1, 5 o 15 minutos), así que en vez de un
// umbral fijo se estima a partir de la mediana de los últimos intervalos
// reales y se lo acota a un rango razonable.
export function computeStaleThreshold(recordedAtAsc: string[]): number {
  if (recordedAtAsc.length < 3) return DEFAULT_STALE_THRESHOLD_MS;

  const gaps: number[] = [];
  for (let i = 1; i < recordedAtAsc.length; i++) {
    gaps.push(new Date(recordedAtAsc[i]).getTime() - new Date(recordedAtAsc[i - 1]).getTime());
  }
  gaps.sort((a, b) => a - b);
  const median = gaps[Math.floor(gaps.length / 2)];

  return Math.min(MAX_STALE_THRESHOLD_MS, Math.max(MIN_STALE_THRESHOLD_MS, median * 3));
}
